@if (photos.length > 0) {
  <div class="mb-2 flex items-center gap-2 px-4">
    @for (photo of photos; track photo.url; let i = $index) {
      <div class="relative">
        <img [src]="photo.url" alt="{{ 'willy.photo.preview-alt' | translate }}"
          class="size-14 rounded-field object-cover" />
        <button type="button"
          class="absolute -right-2 -top-2 flex size-5 items-center justify-center rounded-pill bg-vw-ink text-vw-on-color"
          (click)="removePhoto(i)" [attr.aria-label]="'willy.photo.remove' | translate">
          <vw-close-icon class="size-3"></vw-close-icon>
        </button>
      </div>
    }
  </div>
}
@if (photoError) {
  <p class="mx-4 mb-2 text-caption text-vw-danger">{{ 'willy.photo.error.' + photoError | translate }}</p>
}
<!-- Saisie d'une messagerie : photo, champ, envoyer, en 44 px. -->
<div class="flex items-center gap-2 px-4">
  <input #photoInput type="file" accept="image/jpeg,image/png" multiple class="hidden"
    (change)="onPhotoSelected($event)">
  <button type="button"
    class="relative flex h-target w-target shrink-0 items-center justify-center rounded-pill"
    [ngClass]="disabled ? 'bg-vw-surface-sunk text-vw-muted' : 'bg-vw-surface-tint text-vw-primary active:bg-vw-line'"
    [disabled]="disabled" (click)="onPhotoButtonClick()"
    [attr.aria-label]="(photoLocked ? 'willy.photo.locked' : 'willy.photo.attach') | translate">
    <vw-camera-icon class="size-6"></vw-camera-icon>
    @if (photoLocked) {
      <!-- Le diagnostic offert a servi : le cadenas le dit avant le toucher. -->
      <span class="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-pill bg-vw-premium-ink text-vw-on-color">
        <vw-lock-icon class="h-2.5 w-2.5" />
      </span>
    }
  </button>
  <input type="text" enterkeyhint="send"
    class="h-target min-w-0 grow rounded-pill border border-vw-line bg-vw-surface px-4 text-body text-vw-ink outline-none placeholder:text-vw-muted focus:border-vw-primary disabled:bg-vw-surface-sunk"
    [placeholder]="placeholderKey | translate" [attr.aria-label]="placeholderKey | translate"
    [disabled]="disabled" [(ngModel)]="message"
    (keyup.enter)="onEnter()" (focus)="onInputFocus()" (blur)="onInputBlur()">
  <!-- Envoyer garde le champ et le clavier, comme une messagerie : sans cela, le
       champ perd le focus au toucher, les actions reviennent et le bouton se
       dérobe sous le doigt avant le clic. -->
  <button type="button"
    class="flex h-target w-target shrink-0 items-center justify-center rounded-pill"
    [ngClass]="canSend ? 'bg-vw-primary text-vw-on-color active:bg-vw-primary-pressed' : 'bg-vw-surface-sunk text-vw-muted'"
    [disabled]="disabled" (mousedown)="$event.preventDefault()" (click)="onSendButtonClick()"
    [attr.aria-label]="'willy.send' | translate">
    <vw-send-icon class="h-5 w-5" />
  </button>
</div>
